import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { isEqual } from 'lodash';
import { Observable } from 'rxjs';
import {
  map,
  tap,
  filter,
  publishReplay,
  refCount,
  distinctUntilChanged,
} from 'rxjs/operators';
import { selectCasaSettingsState } from '../state/reducer';
import { LoadCasaSettings } from '../state/casa-settings/actions';
import { CasaSettingsState } from '../state/casa-settings/state';
import { CasaSettings } from '../types/casa-settings.types';

@Injectable({
  providedIn: 'root',
})
export class CasaSettingsFacade {
  readonly settings$: Observable<CasaSettings>;

  constructor(private store: Store<Record<string, unknown>>) {
    this.settings$ = store.pipe(
      select(selectCasaSettingsState),
      map((settingsState) => {
        if (settingsState.error) {
          throw new Error(settingsState.error);
        } else {
          return settingsState;
        }
      }),
      tap((settingsState) => this.loadCasaSettings(settingsState)),
      filter((settingsState) => !!settingsState.settings),
      map((settingsState) => settingsState.settings),
      distinctUntilChanged(isEqual),
      publishReplay(1),
      refCount()
    );
  }

  loadCasaSettings(state: CasaSettingsState) {
    if (!state.error && !state.loading && !state.loaded) {
      setTimeout(() => {
        this.store.dispatch(new LoadCasaSettings());
      }, 1);
    }
  }
}
